module.exports = __webpack_public_path__ + "static/media/simplicity.f0f13fc3.svg";